<template>
  <v-container>
    <PageHeader />
    <v-card elevation="0">
      <v-card-text v-if="plots.isLoading == false">
        Number of plots: {{ plots.totalCount}}
        <v-list three-line>
          <template v-for="(plot, i) in plots.data">
            <v-divider v-if="i != 0" :key="`divider-${plot.Id}`" />
            <PlotHeader :key="plot.Id" :plot="plot" />
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import PlotHeader from '@/components/VegetativeMonitoring/Header/PlotHeader'
  import {
    createNamespacedHelpers,
  } from 'vuex'

  const vegetativemonitoring = createNamespacedHelpers('vegetativemonitoring')

  export default {
    components: {
      PlotHeader,
    },
    computed: {
      ...vegetativemonitoring.mapState(['plots']),
    },
    methods: {
      ...vegetativemonitoring.mapActions(['getPlots']),
      async fetchPlots(forced = false) {
        try {
          await this.getPlots({
            forced,
          })
        } catch (error) {
          console.error(error)
        }
      },
    },
    created() {
      this.fetchPlots()
    },
  }
</script>

<style scoped>
</style>